  //swiper slider js start



    var TwaSettingsSwiper = {

        init: function () {

            this.TwaSettingsCarousel();

        },

        TwaSettingsCarousel: function () {

            document.querySelectorAll(".twa__swiper").forEach((e => {

                this.TwaCarousel(e);

            }))

        },

        TwaCarousel: function (e) {

            var t = "true" === e?.dataset.autoplay,

                n = "true" === e.dataset.loop,

                w = e?.dataset.rows ? e?.dataset.row : 1,

                o = e?.dataset.slideshow ? e?.dataset.slideshow : 0,

                pgm = e?.dataset.spgmobile ? e?.dataset.spgmobile : 1,

                pgt = e?.dataset.spgtablet ? e?.dataset.spgtablet : 1,

                pgd = e?.dataset.spgdesktop ? e?.dataset.spgdesktop : 1,

                i = e?.dataset.desktop ? e?.dataset.desktop : 4,

                s = e?.dataset.tablet ? e?.dataset.tablet : 2,

                r = e?.dataset.mobile ? e?.dataset.mobile : 1,

                a = e?.dataset.autoplaySpeed ? e?.dataset.autoplaySpeed : 3e3,

                c = e?.dataset.speed ? e?.dataset.speed : 400,

                l = e?.dataset.effect ? e?.dataset.effect : "slide",

                d = e?.dataset.sectionId,

                u = e?.dataset.row ? e?.dataset.row : 1,

                ut = e?.dataset.rowtablet ? e?.dataset.rowtablet : 1,

                um = e?.dataset.rowmobile ? e?.dataset.rowmobile : 1,

                p = window.innerWidth,

                m = e?.dataset.spacing ? e?.dataset.spacing : 0;

            cs = "true" === e.dataset.centerslide,

                desktop = parseInt(pgd);

            tablet = parseInt(pgt);

            mobile = parseInt(pgm);

            al = e?.dataset.arrowleft ? e?.dataset.arrowleft : "swiper-button-prev",

                ar = e?.dataset.arrowright ? e?.dataset.arrowright : "swiper-button-next",

                m = Number(m), a = Number(a), c = Number(c), p <= 767 ? m >= 15 && (m = 15) : p <= 1199 && m >= 30 && (m = 30), new Swiper("#twa__swiper-" + d, {

                    slidesPerView: r,

                    slidesPerColumn: w,

                    slidesPerGroup: mobile,

                    spaceBetween: m,

                    centeredSlides: cs,

                    autoplay: t,

                    delay: a,

                    loop: n,

                    effect: l,

                    speed: c,

                    watchSlidesProgress: !0,

                    watchSlidesVisibility: !0,

                    draggable: true,

                    grid: {

                        rows: um,

                        fill: "row"

                    },

                    // navigation: {

                    //     nextEl: e.querySelector(`.${ar}`),

                    //     prevEl: e.querySelector(`.${al}`)

                    // },

                    navigation: {

                        nextEl: `.${ar}`,

                        prevEl: `.${al}`,

                    },

                    autoplay: {

                        delay: 9000,

                    },

                    pagination: {

                        clickable: !0,

                        el: e.querySelector(".swiper-pagination")

                    },

                    breakpoints: {

                        768: {

                            slidesPerView: s,

                            centeredSlides: cs,

                            slidesPerGroup: tablet,

                            grid: {

                                rows: ut,

                                fill: "row"

                            }

                        },

                        1450: {

                            slidesPerView: i,

                            slidesPerGroup: desktop,

                            grid: {

                                rows: u,

                                fill: "row"

                            }

                            //centeredSlides: cs,

                        }

                    }

                })

        }

    };

    TwaSettingsSwiper.init();

    // swiper js end

